import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

import LogoImage from "images/logo.svg";
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as Linkedin } from "images/linkedin-icon.svg";
import { ReactComponent as YoutubeIcon } from "images/youtube-icon.svg";
import { ReactComponent as InstaGramIcon } from "images/instagram.svg";

const Container = tw.div`relative bg-gray-200 text-gray-700 -mb-8 -mx-8 px-8 py-20 lg:py-24`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const SixColumns = tw.div`flex flex-wrap lg:flex-nowrap text-center justify-center gap-6 md:gap-8 lg:gap-4 mx-4 md:mx-8 lg:mx-4 -mt-12`;

const Column = tw.div`px-2 sm:px-4 sm:w-1/4 md:w-auto lg:flex-1 mt-12 text-center flex flex-col items-center`;

const ColumnHeading = tw.h5`uppercase font-bold text-center`;

const LinkList = tw.ul`mt-6 text-sm font-medium text-center list-none flex flex-col items-center`;
const LinkListItem = tw.li`mt-3 text-center`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-700 pb-1 transition duration-300 block text-center`;


const Divider = tw.div`my-16 border-b-2 border-gray-300 w-full`;

const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-32 h-10`;
const LogoText = tw.h5`ml-2 text-xl font-black tracking-wider text-gray-800`;

const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-500`;

const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-900 text-gray-100 hover:bg-gray-700 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default () => {
  return (
    <Container>
      <Content>
        <SixColumns>
          <Column>
            <ColumnHeading>Main</ColumnHeading>
            <LinkList>
              <LinkListItem>
                <Link href="/about-us">About Us</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/contact-us">Contact Us</Link>
              </LinkListItem>
            </LinkList>
          </Column>

          <Column>
            <ColumnHeading>Quick Links</ColumnHeading>
            <LinkList>
            <LinkListItem>
                <Link href="/prevention-of-sexual-harassment">POSH</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/posh-act">Posh Act</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/cippe-details">CIPP/E</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/article-topics">Blog</Link>
              </LinkListItem>
            </LinkList>
          </Column>

          <Column>
            <ColumnHeading>Legal</ColumnHeading>
            <LinkList>
              {/* <LinkListItem>
                <Link href="#">GDPR</Link>
              </LinkListItem> */}
              <LinkListItem>
                <Link href="/privacy-policy">Privacy Policy</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/term-and-services">Terms of Service</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/disclaimer">Disclaimer</Link>
              </LinkListItem>
            </LinkList>
          </Column>

          <Column>
            <ColumnHeading>Contact Details</ColumnHeading>
            <LinkList>
              {/* <LinkListItem>
                <Link href="#">GDPR</Link>
              </LinkListItem> */}
              <LinkListItem>
                <b>Phone: </b><Link href="tel:+91-859-552-0719">+91-859-552-0719</Link>
              </LinkListItem>
              <LinkListItem>
                <b>Address: </b><span tw="text-gray-600">C-404, Ashiana Orchid,<br/>Plot No. GH-01 Gamma 2,<br/>Gautambudh Nagar,Greater Noida,<br/>Uttar Pradesh - 201306</span>
              </LinkListItem>
            </LinkList>
          </Column>
          
        </SixColumns>
        <Divider />
        <ThreeColRow>
          <LogoContainer>
            <LogoImg src={LogoImage} alt="Sequilern - Workplace Compliance Solutions" />
          </LogoContainer>
          <CopywrightNotice>&copy; 2026 Sequilern. All Rights Reserved.</CopywrightNotice>
          <SocialLinksContainer>
            {/* <SocialLink href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
            </SocialLink> */}
            <SocialLink href="https://www.linkedin.com/company/sequilern/" target="_blank" rel="noopener noreferrer">
              <Linkedin />
            </SocialLink>
            {/*<SocialLink href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <YoutubeIcon />
            </SocialLink>*/}
            <SocialLink href="https://www.instagram.com/sequilern?igsh=Njduenh1bjU1cnJo" target="_blank" rel="noopener noreferrer">
              <InstaGramIcon />
            </SocialLink>
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
    </Container>
  );
};
